import * as React from 'react';
import {PopoverButton, TscPopoverOrigin, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import SettingsMenuContainer from '../SettingsMenu/SettingsMenuContainer';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';

export default ({themeName}: Themeable) => {
   return <div className="settings">
      <PopoverButton buttonGlyph={<Glyphs.Settings16x16/>}
         origin={TscPopoverOrigin.bottomRight}
         popoverMenu={<SettingsMenuContainer />}
         themeName={themeName}
         showArrow={false}
         buttonTitle={Strings.labels.preferences.preferencesMenuTitle}
         testId="settings"
         closeMenuOnClick={true} />
   </div>;
};
